module.exports = __webpack_public_path__ + "img/f061f9b000b0e63be01fc70ffe072342.png";